import { render, staticRenderFns } from "./FeedForm.vue?vue&type=template&id=5b39fcfb&"
import script from "./FeedForm.vue?vue&type=script&lang=js&"
export * from "./FeedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports